export default __webpack_public_path__ + "static/media/visa.d916b725.jfif";